import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Components/Navbar';
import LandingPage from './LandingPage';
import ContactUs from './Pages/ContactUs';
import Services from './Services Pages/Services';
import StrategicConsulting from './Services Pages/StrategicConsulting';
import DesignDevelopment from './Services Pages/DesignDevelopment';
import Itstaffing from './Services Pages/Itstaffing';
import DigitalMarketing from './Services Pages/DigitalMarketing';
import CloudSolutions from './Services Pages/CloudSolutions';
import DatabaseSecurity from './Services Pages/DatabaseSecurity';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import AboutUs from './Pages/AboutUs';
import ItStafingBlog from './BlogPages/ItStafingBlog';
import DatabaseSecurityBlog from './BlogPages/DatabaseSecurityBlog';
import CloudInfrastructureBlog from './BlogPages/CloudInfrastructureBlog';
import PageNotFound from './Pages/PageNotFound';
import Footer from './Components/Footer';
import GetQuote from './Pages/GetQuote';

function Routing() {
  return (
    <>
    <Router>
        <Routes>
          <Route path='/' element={<LandingPage/>}/>
         <Route path='/navbar' element={<Header/>}/>
         <Route path='/about-us' element={<AboutUs/>}/>
         <Route path='/contact-us' element={<ContactUs/>}/>
         <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
         <Route path='/terms-conditions' element={<TermsConditions/>}/>
         {/* <Route path='/services' element={<Services/>}/> */}
         <Route path='/get-a-quote' element={<GetQuote/>}/>
         <Route path='/services/it-staffing' element={<Itstaffing/>}/>
         <Route path='/services/strategic-consulting' element={<StrategicConsulting/>}/>
         <Route path='/services/design-development' element={<DesignDevelopment/>}/>
         <Route path='/services/digital-marketing' element={<DigitalMarketing/>}/>
         <Route path='/services/cloud-solutions' element={<CloudSolutions/>}/>
         <Route path='/services/database-security' element={<DatabaseSecurity/>}/>
         <Route path='/blog/it-stafing' element={<ItStafingBlog/>}/>
         <Route path='/blog/database-security' element={<DatabaseSecurityBlog/>}/>
         <Route path='/blog/cloud-infrastructure' element={<CloudInfrastructureBlog/>}/>
         <Route path='/footer' element={<Footer/>}/>
         <Route path="*" element={<PageNotFound/>} />
        </Routes>
      </Router>
    
    </>
  )
}

export default Routing